import { Component, OnInit } from '@angular/core';
import { AuthenticationService, HttpService } from '../_services';
import { NgxSpinnerService } from 'ngx-spinner';
import swal from "sweetalert2";


@Component({
  selector: "app-adhoc",
  templateUrl: "./adhoc.component.html",
  styleUrls: ["./adhoc.component.scss"],
})
export class AdhocComponent implements OnInit {
  CondoList: any;
  constructor(
    private http: HttpService,
    private spinner: NgxSpinnerService,
    private authen: AuthenticationService
  ) {
    this.http.getSpecial().subscribe(
      (res) => {},
      (err) => {
        this.authen.logout();
      }
    );
  }

  cdid: any;
  floor: any;
  price: any;

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.spinner.show();
    this.http.requestGet("condo").subscribe(
      (res) => {
        this.CondoList = res;
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
        if (err.status == 404) {
          swal("ไม่พบข้อมูล", "ไม่พบข้อมูลที่เกี่ยวข้อง", "error");
        }
      }
    );
  }

  updatePrice() {
    this.http
      .requestPut(
        "condo/" + this.cdid + "/" + this.floor + "/" + this.price,
        {}
      )
      .subscribe((res) => {
        swal({
          title: "แก้ไขเรียบร้อยแล้ว",
          showConfirmButton: false,
          timer: 500,
          type: "success",
        });
      });
  }
}
